import { useTheme } from '@mui/styles';

import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    pendingBlue: {
      color: legacyColors.primary,
      whiteSpace: 'pre-wrap',
    },
    pendingGreen: {
      color: legacyColors.green2,
      whiteSpace: 'pre-wrap',
    },
    icon: {
      marginRight: theme.spacing(0.5),
      paddingTop: '3px',
    },
  };
};
